import { LANGUAGE_SELECTOR_MAP } from 'app/components/molecules/LanguageSwitcher/constants';
import { LanguageIDType } from 'types/UITypes';
import { AvailableLanguage } from './types';

export const transformDTO = (data: AvailableLanguage[]) => {
  return data.map(lng => {
    const lang = parseInt(lng.countryCode, 10) as LanguageIDType;
    const switcherItem = LANGUAGE_SELECTOR_MAP[lang];

    return { ...switcherItem };
  });
};
